// @flow
import React from "react";
import { NumberField } from "@quantum/ui";
import { Translate } from "@quantum/i18n";
import { connect } from "react-redux";
import {
  type ActionCreator,
  editarConfianca,
  getConfiancaSelecionada,
  getSeparadorDecimal,
} from "../../../../state";
import { VALOR_DEFAULT_CONFIANCA } from "../../../../model";

type Prop = {
  confianca: number,
  separadorDecimal: string,
  editarConfianca: ActionCreator,
  className?: ?string,
};

function SelecaoConfianca({
  confianca,
  separadorDecimal,
  editarConfianca,
  className,
}: Prop) {
  function handleConfiancaEditado(confianca) {
    editarConfianca(confianca);
  }

  function onBlur() {
    if (confianca !== 0 && !confianca) {
      editarConfianca(VALOR_DEFAULT_CONFIANCA);
    }
  }

  return (
    <div>
      <Translate className="ConfiguracaoMedida__label--no-margin">
        Comum.Confianca
      </Translate>
      <NumberField
        className={className}
        allowNegative={false}
        decimalScale={1}
        max={99.9}
        min={0.1}
        onChangeValue={handleConfiancaEditado}
        value={confianca}
        thousandSeparator={""}
        suffix={"%"}
        decimalSeparator={separadorDecimal}
        onBlur={onBlur}
      />
    </div>
  );
}

export default connect(
  state => ({
    confianca: getConfiancaSelecionada(state),
    separadorDecimal: getSeparadorDecimal(state),
  }),
  { editarConfianca }
)(SelecaoConfianca);
